import app from './app';
import createEvent from "./create-event";

const FIELD_TYPE_TEXT = 1;
const FIELD_TYPE_TEXTAREA = 2;
const FIELD_TYPE_SELECT = 3;
const FIELD_TYPE_RADIO = 4;
const FIELD_TYPE_CHECKBOX = 5;
const FIELD_TYPE_FILE = 6;

export default class HtmlHelper {
    static createElement(htmlString) {
        let domParser = new DOMParser();
        let pseudoDocument = domParser.parseFromString(htmlString, "text/html");
        return pseudoDocument.body.firstChild;
    }

    static safeAddEventListener(element) {
        if (element) {
            let args = [...arguments].slice(1);
            element.addEventListener.apply(element, args);
        }
    }

    static hasElementParentWithClass(target, parentClass, includeSelf = true) {
        return this.getElementParentWithClass(target, parentClass, includeSelf) !== null;
    }

    static getElementParentWithClass(target, parentClass, includeSelf = true) {

        if (includeSelf && target.classList.contains(parentClass)) {
            return target;
        }

        let parent = target.parentElement;
        while (parent !== null) {
            if (parent.classList.contains(parentClass)) {
                return parent;
            }
            parent = parent.parentElement;
        }

        return null;
    }

    static isHtmlElement(element) {
        return typeof element === 'object' && ('nodeType' in element);
    }

    static getSrcSet(imageUrl, addSizes = []) {
        let defaultSizes = [320, 360, 640, 720, 1280, 1440];
        let sizes = [...defaultSizes];

        if (addSizes && addSizes.length > 0) {
            sizes = [...sizes, ...addSizes];
        }

        if (!imageUrl || imageUrl.length === 0) {
            imageUrl = app.getConfig('defaultImageUrl', null);
        }

        if (imageUrl === null) {
            return "";
        }

        return sizes.map(width => `${HtmlHelper.GetResizedMediaUrl(imageUrl, width)} ${width}w`).join(', ');
    }

    static GetResizedMediaUrl(imageUrl, width) {
        if (imageUrl) {
            imageUrl = imageUrl.replace(/(~)|&?(width|height)=[0-9]+/, "");
            imageUrl = imageUrl.replace(/\?&/, "");
            imageUrl = imageUrl.replace(/(\?|&)$/, "");

            let paramsPrefix = imageUrl.indexOf('?') === -1 ? '?' : '&';
            imageUrl = imageUrl + paramsPrefix;
            return imageUrl + "width=" + width;
        }

        return '';
    }

    static getSectionFormFields(root) {
        return [...root.querySelectorAll('input, select, textarea')];
    }

    static resetFormSection(root) {
        this.getSectionFormFields(root).forEach(field => this.resetFormField(field));
    }

    static resetFormSections(sections) {
        sections.forEach((section) => this.resetFormSection(section));
    }

    static isTextField(element) {
        return this.getFieldType(element) === FIELD_TYPE_TEXT;
    }

    static isTextareaField(element) {
        return this.getFieldType(element) === FIELD_TYPE_TEXTAREA;
    }

    static isCheckboxField(element) {
        return this.getFieldType(element) === FIELD_TYPE_CHECKBOX;
    }

    static isSelectField(element) {
        return this.getFieldType(element) === FIELD_TYPE_SELECT;
    }

    static getFieldType(element) {
        let result = null;

        switch (element.tagName) {
            case 'INPUT':
                switch (element.type) {
                    case 'text':
                        result = FIELD_TYPE_TEXT;
                        break;
                    case 'radio':
                        result = FIELD_TYPE_RADIO;
                        break;
                    case 'checkbox':
                        result = FIELD_TYPE_CHECKBOX;
                        break;
                    case 'file':
                        result = FIELD_TYPE_FILE;
                        break;
                }
                break;
            case 'TEXTAREA':
                result = FIELD_TYPE_TEXTAREA;
                break;
            case 'SELECT':
                result = FIELD_TYPE_SELECT;
                break;
        }
        return result;
    }

    static resetFormField(element) {
        if (this.isHtmlElement(element)) {
            let type = this.getFieldType(element);
            if (type) {
                switch (type) {
                    case FIELD_TYPE_TEXT:
                    case FIELD_TYPE_TEXTAREA:
                    case FIELD_TYPE_FILE:
                        element.value = element.defaultValue;
                        break;
                    case FIELD_TYPE_SELECT:
                        [...element.querySelectorAll('option')].forEach(option => option.selected = option.defaultSelected);
                        break;
                    case FIELD_TYPE_RADIO:
                    case FIELD_TYPE_CHECKBOX:
                        element.checked = element.defaultChecked;
                        break;
                }
            }
        }
    }

    static hasFormSectionsDirtyFields(sections) {
        return sections.some((section) => this.hasFormSectionDirtyFields(section));
    }

    static hasFormSectionDirtyFields(root) {
        return this.getSectionFormFields(root).some(field => this.isFieldDirty(field));
    }

    static isFieldDirty(element) {
        let result = false;

        let type = this.getFieldType(element);
        if (type) {
            switch (type) {
                case FIELD_TYPE_TEXT:
                case FIELD_TYPE_TEXTAREA:
                case FIELD_TYPE_FILE:
                    result = element.value !== element.defaultValue;
                    break;
                case FIELD_TYPE_SELECT:
                    result = [...element.querySelectorAll('option')].some(option => option.selected !== option.defaultSelected);
                    break;
                case FIELD_TYPE_RADIO:
                case FIELD_TYPE_CHECKBOX:
                    result = element.checked !== element.defaultChecked;
                    break;
            }
        }

        return result;
    }

    static hideFormHiddenGroup(confirmationCheckboxesSection) {
        confirmationCheckboxesSection.setAttribute('data-hidden-group', 'is-hidden');
    }

    static showFormHiddenGroup(confirmationCheckboxesSection) {
        confirmationCheckboxesSection.setAttribute('data-hidden-group', '');
    }
}



// WEBPACK FOOTER //
// ./app/general/js/html-helper.js